import { render, staticRenderFns } from "./threeinfo.vue?vue&type=template&id=a3b89f3a&scoped=true&"
import script from "./threeinfo.vue?vue&type=script&lang=js&"
export * from "./threeinfo.vue?vue&type=script&lang=js&"
import style0 from "./threeinfo.vue?vue&type=style&index=0&id=a3b89f3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b89f3a",
  null
  
)

export default component.exports